<div class="modal-header">
    <h4 class="modal-title fs-5 text-reset text-capitalize">Normtider</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Luk"></button>
</div>
<div class="norm-toolbar d-flex flex-wrap align-items-center gap-2 px-3 py-1 border-bottom flex-shrink-0">
    <label class="mb-0" for="norm-employee">Medarbejder</label>
    <ng-select class="norm-employee ng-select-sm" labelForId="norm-employee"
               [ngModel]="selectedMedarbejder()" (ngModelChange)="onUserChange($event)"
               [disabled]="busy()" [clearable]="false" [searchable]="true"
               dropdownPosition="auto" placeholder="Vælg medarbejder" notFoundText="Ingen medarbejdere fundet">
        @for (user of activeUsers(); track user.cardId) {
            <ng-option [value]="user">{{ user.brugerId }} · {{ user.fornavn }} {{ user.efternavn }}</ng-option>
        }
    </ng-select>
    <label class="mb-0 ms-2" for="norm-year">År</label>
    <input id="norm-year" class="norm-year-input form-control form-control-sm" type="number" min="1900" max="9999"
           [disabled]="busy()" [ngModel]="currentYear()" (ngModelChange)="onYearChange($event)" />
    <button class="btn btn-primary btn-sm ms-auto" [disabled]="!canEdit()" (click)="openFravaerModal()">Planlagt fravær</button>
    <div ngbDropdown container="body" placement="bottom-end">
        <button class="btn btn-outline-primary btn-sm" ngbDropdownToggle [disabled]="!canEdit()">Kopier</button>
        <div ngbDropdownMenu>
            <button ngbDropdownItem (click)="copyToOtherEmployee()">Til anden medarbejder…</button>
            <button ngbDropdownItem (click)="copyToNextYear()">Til næste år…</button>
        </div>
    </div>
</div>
<div class="modal-body employee-scroll flex-shrink-1 overflow-auto px-3 py-0" [attr.aria-busy]="normtiderStore.loading()">
    @if (normtiderStore.loading()) {
        <p class="py-3 mb-0 text-body-secondary" role="status">Henter normtider…</p>
    } @else if (normtiderStore.loadError()) {
        <div class="alert alert-danger my-2" role="alert">
            Normtiderne kunne ikke hentes.
            <button class="btn btn-sm btn-outline-danger ms-2" (click)="reload()">Prøv igen</button>
        </div>
    } @else if (!selectedMedarbejder()) {
        <p class="py-3 mb-0 text-body-secondary">Ingen aktive medarbejdere.</p>
    } @else {
        <div class="norm-legend d-flex flex-wrap align-items-center gap-3 small text-body-secondary">
            <span><i class="norm-swatch norm-weekend"></i>Weekend</span>
            <span><i class="norm-swatch norm-holiday"></i>Hellig-/fridag</span>
            @for (type of absenceTypes; track type.code) {
                <span><i [class]="'norm-swatch norm-absence-' + type.code"></i>{{ type.label }}</span>
            }
            <span class="ms-auto">Normtimer · tt:mm</span>
        </div>
        <div class="row gx-1">
            @for (month of calendar(); track month.month) {
                <section class="col-6 col-sm-4 col-md-2 col-xl-1" [attr.aria-label]="month.name">
                    <h5 class="norm-month text-capitalize border-bottom ps-1 mb-0">{{ month.name }}</h5>
                    @for (day of month.days; track day.key) {
                        <div class="norm-day d-flex align-items-center px-1"
                             [class.norm-weekend]="day.weekend && !day.holiday" [class.norm-holiday]="day.holiday"
                             [class.norm-absence-1]="day.kodeValue === 1" [class.norm-absence-2]="day.kodeValue === 2"
                             [class.norm-absence-3]="day.kodeValue === 3" [class.norm-absence-4]="day.kodeValue === 4"
                             [class.norm-selected]="selectedDate() === day.key" (focusin)="onDayClick(day)"
                             (click)="onDayClick(day); hourEditor.focus()">
                            <span class="norm-date text-start" aria-hidden="true">
                                <span class="d-inline-block text-end">{{ day.dayNumber }}</span> {{ day.dayName }}
                            </span>
                            <app-medarbejdere-hour-input #hourEditor class="norm-hour flex-grow-1" [compact]="true"
                                [label]="'Normtid ' + day.label + (day.kodeValue ? ', ' + absenceLabel(day.kodeValue) : '')"
                                [id]="day.key" [timer]="day.timerValue" [kode]="day.kodeValue"
                                [disabled]="!canEdit()" [dayTotal]="day.timerValue || 0"
                                (saveTimer)="onTimerSaved($event, day)">
                            </app-medarbejdere-hour-input>
                        </div>
                    }
                </section>
            }
        </div>
    }
</div>
<div class="norm-footer d-flex flex-wrap align-items-center gap-2 px-3 border-top flex-shrink-0">
    @if (selectedDay(); as day) {
        <span class="text-capitalize" aria-live="polite">{{ day.label }} · {{ day.timerValue === null ? 'Ikke angivet' : (day.timerValue | time) }}{{ day.kodeValue ? ' · ' + absenceLabel(day.kodeValue) : '' }}</span>
        <button class="btn btn-sm btn-link text-decoration-none" [disabled]="!canEdit() || day.timerValue === null" (click)="copyWeekday()">Kopier til {{ selectedWeekday() }}…</button>
        @if (day.kodeValue) {
            <button class="btn btn-sm btn-link text-danger text-decoration-none" [disabled]="!canEdit()" (click)="removeFravaer(day, $event)">Fjern fravær</button>
        }
    } @else {
        <span class="text-body-secondary">Vælg en dag for at kopiere normtid</span>
    }
    <span class="small text-body-secondary ms-auto">{{ normtiderStore.saving() ? 'Gemmer…' : 'Gemmes ved Enter eller når feltet forlades' }}</span>
</div>
